import { toast } from 'react-hot-toast';
import logger from '../../utils/logger';

const createScreenshotSlice = (set, get) => ({
    // Ekran görüntüsü state'i
    screenshot: null,

    // Ekran görüntüsü al
    takeScreenshot: () => {
        try {
            const { localStream, remoteStream } = get();

            // Hem sınıf adları ile hem de video etiketleri ile bulmayı dene
            let localVideo = document.querySelector('.local-video');
            let remoteVideo = document.querySelector('.remote-video');

            // Eğer sınıflar ile bulunamazsa, tüm video elementlerini dene
            if (!localVideo || !remoteVideo) {
                const videos = document.querySelectorAll('video');

                // En az 2 video elementi olmalı (yerel ve uzak)
                if (videos.length >= 2) {
                    // Uzak video genellikle daha büyük olur
                    // Muted özelliği olmayan video genellikle uzak videodur
                    for (const video of videos) {
                        if (!video.muted) {
                            remoteVideo = video;
                        } else {
                            localVideo = video;
                        }
                    }

                    // Hala bulunamadıysa, ilk iki videoyu kullan
                    if (!localVideo) localVideo = videos[0];
                    if (!remoteVideo) remoteVideo = videos[1];
                }
            }

            if (!localVideo || !remoteVideo) {
                // Görüşme aktif değilken video elementleri bulunmaz - beklenen durum, sessizce çık
                return;
            }

            /*             console.log('Video elementleri bulundu:', {
                        localVideo: localVideo.videoWidth + 'x' + localVideo.videoHeight,
                            remoteVideo: remoteVideo.videoWidth + 'x' + remoteVideo.videoHeight
                    }); */

            // Canvas oluştur
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Video boyutlarını al
            const remoteWidth = remoteVideo.videoWidth || remoteVideo.clientWidth || 640;
            const remoteHeight = remoteVideo.videoHeight || remoteVideo.clientHeight || 480;
            const localWidth = localVideo.videoWidth || localVideo.clientWidth || 640;
            const localHeight = localVideo.videoHeight || localVideo.clientHeight || 480;

            // Canvas boyutlarını belirle - Yan yana iki video için
            const maxHeight = Math.max(remoteHeight, localHeight);
            const totalWidth = remoteWidth + localWidth;

            canvas.width = totalWidth;
            canvas.height = maxHeight;

            /*         console.log('Canvas boyutları:', {
                    width: canvas.width,
                        height: canvas.height,
                            remoteVideo: `${remoteWidth}x${remoteHeight}`,
                                localVideo: `${localWidth}x${localHeight}`
                }); */

            // Arka plan rengini ayarla (siyah)
            ctx.fillStyle = '#000000';
            ctx.fillRect(0, 0, totalWidth, maxHeight);

            // Sol tarafta uzak video (müşteri)
            const remoteY = (maxHeight - remoteHeight) / 2; // Dikey ortalama için
            ctx.drawImage(remoteVideo, 0, remoteY, remoteWidth, remoteHeight);

            // Sağ tarafta yerel video (temsilci)
            const localY = (maxHeight - localHeight) / 2; // Dikey ortalama için
            ctx.drawImage(localVideo, remoteWidth, localY, localWidth, localHeight);

            // Video'ların arasına ayırıcı çizgi ekle
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(remoteWidth, 0);
            ctx.lineTo(remoteWidth, maxHeight);
            ctx.stroke();

            // Video etiketleri ekle
            ctx.font = 'bold 28px Arial';
            ctx.fillStyle = '#ffffff';
            ctx.strokeStyle = '#000000';
            ctx.lineWidth = 3;

            // Müşteri etiketi (sol üst)
            const customerText = 'Müşteri';
            ctx.strokeText(customerText, 10, 25);
            ctx.fillText(customerText, 10, 25);

            // Temsilci etiketi (sağ üst)  
            const agentText = 'Temsilci';
            ctx.strokeText(agentText, remoteWidth + 10, 25);
            ctx.fillText(agentText, remoteWidth + 10, 25);

            // Timestamp ekle (alt ortada)
            const timestamp = new Date().toLocaleString('tr-TR');
            const timestampText = `Tarih: ${timestamp}`;
            ctx.font = 'bold 32px Arial';
            const textWidth = ctx.measureText(timestampText).width;
            const timestampX = (totalWidth - textWidth) / 2;
            ctx.strokeText(timestampText, timestampX, maxHeight - 10);
            ctx.fillText(timestampText, timestampX, maxHeight - 10);

            // Canvas'ı resim olarak al
            const dataURL = canvas.toDataURL('image/png');

            // Store'a screenshot'ı kaydet
            set({ screenshot: dataURL });

            // Ses efekti çal
            try {
                const audio = new Audio('/sounds/take-screenshot.mp3');
                audio.volume = 0.3; // Ses seviyesini %30'a ayarla
                audio.play().catch(error => {
                    console.warn('Ses efekti çalınamadı:', error);
                });
            } catch (audioError) {
                console.warn('Ses efekti yüklenemedi:', audioError);
            }


            // Screenshot'ı store'a kaydettikten sonra kısa bir süre sonra temizle
            // Bu sayede ScreenshotCapture bileşeni screenshot'ı alabilir
            setTimeout(() => {
                set({ screenshot: null });
            }, 100);

            return dataURL;
        } catch (error) {
            logger.error('Ekran görüntüsü alınırken hata:', error);
            return null;
        }
    },

    // Yeni fonksiyon ekle
    clearScreenshots: () => {
        set({ screenshot: null });
    }
});

export default createScreenshotSlice; 
